import styled from 'styled-components';
import {
  Avatar,
} from 'antd';
import {
  COLOR_CV_1,
  COLOR_CV_6,
} from 'constants/colors';

export const StyledAntdAvatar = styled(Avatar)`
  color: ${COLOR_CV_6};
  background-color: ${COLOR_CV_1};
  font-weight: 500;
`;
